export function throwIteratorAccessError() {
  throw new RangeError("Iterator access denied!");
}